const schema = () => ({
  type: "object",
  required: ["lastname", "firstname", "cellphone"],
  properties: {
    firstname: {
      type: "string",
      title: "نام پزشک",
    },
    lastname: {
      type: "string",
      title: "نام خانوادگی",
    },
    cellphone: {
      type: "string",
      title: "شماره همراه",
      minLength: 9,
    },
    national_code: {
      type: "string",
      title: "کد ملی",
      pattern: "^[0-9]*$",
      minLength: 10,
      maxLength: 10,
    },
    birth_date: {
      type: "string",
      title: "تاریخ تولد",
    },
    medical_number: {
      type: "string",
      title: "شماره نظام پزشکی",
      pattern: "^[0-9]*$",
      minLength: 5,
      maxLength: 16,
    },
    specialist: {
      type: "string",
      title: "تخصص",
      oneOf: [
        {
          const: "generalDentist",
          title: "دندانپزشک عمومی",
        },
        {
          const: "orthodontist",
          title: "متخصص ارتودنسی",
        },
        {
          const: "endodontist",
          title: "متخصص درمان ریشه",
        },
        {
          const: "prosthodontist",
          title: "متخصص پروتزهای دندانی و ایمپلنت",
        },
        {
          const: "pedodontist",
          title: "متخصص دندانپزشکی کودکان",
        },
        {
          const: "oralAndMaxillofacialRadiologist",
          title: "متخصص رادیولوژی دهان، فک و صورت",
        },
        {
          const: "oralAndMaxillofacialSurgeon",
          title: "متخصص جراحی دهان، فک و صورت",
        },
        {
          const: "periodontist",
          title: "متخصص جراحی لثه و ایمپلنت",
        },
        {
          const: "restorativeAndAestheticDentist",
          title: "متخصص دندانپزشکی ترمیمی و زیبایی",
        },
        {
          const: "oralAndMaxillofacialPathologist",
          title: "متخصص آسیب شناسی دهان، فک و صورت",
        },
      ],
    },
    gender: {
      type: "number",
      title: "جنسیت",
      oneOf: [
        { const: 1, title: "مرد" },
        { const: 0, title: "زن" },
      ],
    },
  },
});

export default schema;
